module.exports = __webpack_public_path__ + "static/media/Episode_Hero_Tablet_1.997d1979.png";